// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      // Get all tab blocks on the page
      ui.blocks = doms(".block.tabs");

      // Iterate over the blocks to bind to each
      for (var index = 0; index < ui.blocks.length; index++) {
        block.bind(ui.blocks[index]);
      }

      // Bind the handler to the key down event on the document
      document.addEventListener("keydown", block.keydown);

    },

    /**
     * Method to handle binding to the DOM elements.
     *
     * @method block.bind
     */
    bind: function(parent) {

      // Get the DOM element references
      var tabs = doms(".tab-links[role='tablist'] .tab-link", parent);
      var panels = doms(".tab-panel", parent);

      // Placeholder for the active tab
      var active = 0;

      // Skip if there aren't tabs and panels
      if (tabs.length === 0 || panels.length === 0) {
        if (parent.classList.contains("sticky")) {
          block.handleStickyNav(parent);
        }
        return;
      }

      // Iterate over the tabs
      for (var index = 0; index < tabs.length; index++) {
        var tab = tabs[index];
        tab.onclick = block.click.bind(tab, tabs, panels);
        if (!parent.classList.contains("sticky")) {
          tab.setAttribute("aria-selected", index === active ? "true" : "false");
          tab.setAttribute("tabindex", index === active ? "0" : "-1");
        }
      }

      // Iterate over the panels
      for (var index = 0; index < panels.length; index++) {
        var panel = panels[index];
        panel.setAttribute("aria-hidden", index === active ? "false" : "true");
        panel.setAttribute("aria-expanded", index === active ? "true" : "false");
      }

    },

    /**
     * Method to handle sticky nav anchor link scrolling.
     *
     * @method block.handleStickyNav
     */
    handleStickyNav: function(parent) {

      // Get the tab links
      var tabs = doms(".tab-link", parent);

      // Iterate over the tabs to fix anchor links and sticky header
      for (var index = 0; index < tabs.length; index++) {
        block.handleStickyNavItem(tabs[index], parent);
      }

    },

    /**
     * Method to handle sticky nav anchor link scrolling.
     *
     * @method block.handleStickyNavItem
     */
    handleStickyNavItem: function(tab, parent) {

      var href = tab.getAttribute("href");

      // Only handle scrolling on anchor nav items
      if (href.indexOf("#") !== 0) {
        return;
      }

      tab.onclick = function(event) {

        event.preventDefault();

        var body = document.documentElement || document.body;
        var anchor = document.querySelector(tab.getAttribute("href"));

        if (!anchor) {
          return;
        }

        // Get the element position from the top of the page, not viewport
        var top = anchor.getBoundingClientRect().top + window.scrollY;

        // Sroll to the top position, less the height of the sticky
        // Remove an extra pixel to prevent the bottom of above div showing
        body.scrollTop = top - parent.offsetHeight - 1;

      };

    },

    /**
     * Method to handle clicking on the tab links.
     *
     * @method block.click
     */
    click: function(elements, panels, event) {

      // Prevent default link functionality
      event.preventDefault();

      // Get the elements as an array
      elements = utils.convertNodeListToArray(elements);

      // Get the current index
      var active = elements.indexOf(this);

      // Iterate over the elements
      for (var index = 0; index < elements.length; index++) {
        var tab = elements[index];
        tab.setAttribute("aria-selected", index === active ? "true" : "false");
        tab.setAttribute("tabindex", index === active ? "0" : "-1");
      }

      // Iterate over the panels
      for (var index = 0; index < panels.length; index++) {
        var panel = panels[index];
        panel.setAttribute("aria-hidden", index === active ? "false" : "true");
        panel.setAttribute("aria-expanded", index === active ? "true" : "false");
      }

    },

    /**
     * Method to handle the tabs with the keyboard input.
     *
     * @method block.keydown
     */
    keydown: function(event) {

      var key = event.which;

      // Get the active element
      var active = document.activeElement;

      // Switch logic based on key pressed
      switch(key) {

        // Handle on press of the tab or enter/return keys
        case config.keys.TAB:
        case config.keys.RETURN:

          // If a tab link has focus
          if (active.classList.contains("tab-link")) {
            // Get the current tab links as an array
            var tabs = utils.convertNodeListToArray(
              doms(".tab-link", active.parentNode.parentNode)
            );
            // Get the index of the current tab
            var index = tabs.indexOf(active);
            // Get the ID of the panel
            var id = active.getAttribute("aria-controls");
            // Iterate over the tabs
            for (var i = 0; i < tabs.length; i++) {
              var tab = tabs[i];
              tab.setAttribute("aria-selected", index === i ? "true" : "false");
              tab.setAttribute("tabindex", index === i ? "0" : "-1");
              var panel = document.getElementById(tab.getAttribute("aria-controls"));
              if (panel) {
                panel.setAttribute("aria-hidden", index === i ? "false" : "true");
                panel.setAttribute("aria-expanded", index === i ? "true" : "false");
              }
            }
            // Focus on the tab panel
            var element = document.getElementById(id);
            if (element) {
              // Prevent default tabbing functionality
              event.preventDefault();
              element.focus();
            }
          }

          break;

        // Handle on press of the up/down/right/left keys
        case config.keys.UP:
        case config.keys.DOWN:
        case config.keys.RIGHT:
        case config.keys.LEFT:

          // If a tab link has focus
          if (active.classList.contains("tab-link")) {
            // Prevent default tabbing functionality
            event.preventDefault();
            // Get the current tab links as an array
            var tabs = utils.convertNodeListToArray(
              doms(".tab-link", active.parentNode.parentNode)
            );
            // Get the direction, incremented index and list count
            var next = key === config.keys.RIGHT || key === config.keys.DOWN;
            var index = tabs.indexOf(active) + (next ? 1 : -1);
            var count = tabs.length;
            // Allow wrapping around ends of list
            if (next) {
              index = index >= count ? 0 : index;
            } else {
              index = index < 0 ? count - 1 : index;
            }
            // Focus on the next tab
            tabs[index].focus();
          }

          break;

      }

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
